import { useEffect } from 'react'

interface Radio {
  trigger: (arg: string) => void
  vent: {
    on: (event: string, callback: () => void) => void
    off: (event: string, callback: () => void) => void
  }
}

interface Arguments {
  radio?: Radio
  onSave: () => void
}

export function usePostSaveCallback({ radio, onSave }: Arguments) {
  useEffect(() => {
    if (radio) {
      radio.vent.on('post:save:started', onSave)
      return () => {
        radio.vent.off('post:save:started', onSave)
      }
    }
  }, [radio, onSave])
}
